export const incidentOpsTour = {
    module: 'incident_ops',
    title: 'Incident Operations Tour',
    title_vi: 'Tour Vận hành sự cố',
    description: 'As the Incident Commander (P-VN-09), activate response playbooks, track SLA compliance against the 72-hour PDPL notification window, manage escalations, and coordinate vendor response.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Incident Commander (P-VN-09), activate response playbooks, track SLA compliance against the 72-hour PDPL notification window, manage escalations, and coordinate vendor response.',
    estimated_duration_seconds: 32,
    steps: [
        {
            step_id: 'open_incident_ops',
            navigate_to: '/admin/incident-ops/sla-dashboard',
            target: '.dm-page',
            title: 'SLA Dashboard',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: SLA Dashboard',
            wait_for: '.dm-page',
            description: 'Unlike the Incidents module (which handles detection and reporting), Incident Ops manages operational response. This dashboard tracks SLA compliance against the 72-hour PDPL notification window and internal response targets.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Unlike the Incidents module (which handles detection and reporting), Incident Ops manages operational response. This dashboard tracks SLA compliance against the 72-hour PDPL notification window and internal response targets.',
            position: 'top',
        },
        {
            step_id: 'sla_metrics',
            target: '.dm-page > div:nth-child(2)',
            title: 'SLA Metrics at a Glance',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: SLA Metrics at a Glance',
            description: 'As the Incident Commander, monitor SLA compliance rate, breached SLAs, and average acknowledgment/resolution times. Breached SLAs on PDPL-notifiable incidents require immediate escalation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Incident Commander, monitor SLA compliance rate, breached SLAs, and average acknowledgment/resolution times. Breached SLAs on PDPL-notifiable incidents require immediate escalation.',
            position: 'bottom',
        },
        {
            step_id: 'sla_export',
            target: '.dm-btn-secondary',
            title: 'Export SLA Data',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export SLA Data',
            description: "Export SLA metrics for board reporting or PDP Committee submissions, documenting your organization's incident response effectiveness.",
            description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export SLA metrics for board reporting or PDP Committee submissions, documenting your organization's incident response effectiveness.",
            position: 'bottom',
        },
        {
            step_id: 'playbooks_list',
            navigate_to: '/admin/incident-ops/playbooks',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Incident Playbooks',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident Playbooks',
            description: 'Playbooks define step-by-step response procedures activated when an incident is reported in the Incidents module. Each playbook maps to severity levels and ensures consistent PDPL-compliant breach handling.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Playbooks define step-by-step response procedures activated when an incident is reported in the Incidents module. Each playbook maps to severity levels and ensures consistent PDPL-compliant breach handling.',
            position: 'bottom',
        },
        {
            step_id: 'create_playbook',
            target: '.dm-header .btn-primary',
            title: 'Create a Playbook',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Playbook',
            description: 'Define a new response playbook. Common playbooks include data breach notification, ransomware containment, and insider threat response.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define a new response playbook. Common playbooks include data breach notification, ransomware containment, and insider threat response.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'playbook_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Playbook Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Playbook Form',
            description: 'Define the playbook scenario, applicable severity levels, and response steps. Executed playbooks produce audit-grade evidence of your structured PDPL breach response.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Define the playbook scenario, applicable severity levels, and response steps. Executed playbooks produce audit-grade evidence of your structured PDPL breach response.',
            position: 'right',
        },
        {
            step_id: 'escalation_rules',
            navigate_to: '/admin/incident-ops/escalations',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Escalation Log',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Escalation Log',
            description: 'Immutable record of all escalation events. PDPL-notifiable breaches that breach the 72-hour window are automatically flagged for DPO and management escalation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Immutable record of all escalation events. PDPL-notifiable breaches that breach the 72-hour window are automatically flagged for DPO and management escalation.',
            position: 'top',
        },
        {
            step_id: 'create_escalation',
            target: '.dm-header .btn-primary',
            title: 'Log an Escalation',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Log an Escalation',
            description: 'Manually log an escalation when automated rules are insufficient. Each escalation entry becomes part of the incident audit trail.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Manually log an escalation when automated rules are insufficient. Each escalation entry becomes part of the incident audit trail.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'escalation_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Escalation Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Escalation Form',
            description: 'Document the escalation with incident reference, type, target level, and justification. This record demonstrates proper chain-of-command during regulatory investigations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Document the escalation with incident reference, type, target level, and justification. This record demonstrates proper chain-of-command during regulatory investigations.',
            position: 'right',
            action: { type: 'click', target: '.dm-modal-actions button[type="button"]' },
            duration_ms: 300,
        },
        {
            step_id: 'response_metrics',
            navigate_to: '/admin/incident-ops/metrics',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Response Metrics',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Response Metrics',
            description: 'Per-incident SLA tracking with elapsed time, warning thresholds, and breach indicators. Critical for monitoring the 72-hour PDPL notification countdown on active breaches.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Per-incident SLA tracking with elapsed time, warning thresholds, and breach indicators. Critical for monitoring the 72-hour PDPL notification countdown on active breaches.',
            position: 'bottom',
        },
        {
            step_id: 'start_sla_clock',
            target: '.dm-header .dm-btn-primary',
            title: 'Start SLA Clock',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start SLA Clock',
            description: 'Start the SLA timer for a specific incident. For PDPL-notifiable breaches, the 72-hour clock begins from breach confirmation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start the SLA timer for a specific incident. For PDPL-notifiable breaches, the 72-hour clock begins from breach confirmation.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .dm-btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'sla_clock_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Start SLA Clock Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Start SLA Clock Form',
            description: 'Configure the SLA definition, metric type, and threshold. For PDPL breach notification, set the threshold to 72 hours to align with regulatory requirements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure the SLA definition, metric type, and threshold. For PDPL breach notification, set the threshold to 72 hours to align with regulatory requirements.',
            position: 'right',
        },
        {
            step_id: 'vendor_coordination',
            navigate_to: '/admin/incident-ops/vendor-coordination',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Vendor Coordination',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Vendor Coordination',
            description: 'Coordinate with third-party processors involved in breach response. PDPL requires processors to notify controllers without undue delay when they detect a breach.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Coordinate with third-party processors involved in breach response. PDPL requires processors to notify controllers without undue delay when they detect a breach.',
            position: 'bottom',
        },
        {
            step_id: 'create_vendor_coord',
            target: '.dm-header .btn-primary',
            title: 'Add Vendor Coordination',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Add Vendor Coordination',
            description: 'Register a vendor contact involved in breach response. Document all communications for the regulatory audit trail.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Register a vendor contact involved in breach response. Document all communications for the regulatory audit trail.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'vendor_coord_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Vendor Coordination Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Vendor Coordination Form',
            description: 'Link the vendor to the incident with contact details and initial assessment. This coordination record proves processor notification compliance under PDPL.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Link the vendor to the incident with contact details and initial assessment. This coordination record proves processor notification compliance under PDPL.',
            position: 'right',
        },
        {
            step_id: 'regulator_exports',
            navigate_to: '/admin/incident-ops/regulator-exports',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Regulator Exports',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Regulator Exports',
            description: 'Generate formatted breach notification reports for PDP Committee submission. Each export tracks submission status with a watermark proving the notification was prepared within the 72-hour PDPL window.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate formatted breach notification reports for PDP Committee submission. Each export tracks submission status with a watermark proving the notification was prepared within the 72-hour PDPL window.',
            position: 'bottom',
        },
        {
            step_id: 'create_export',
            target: '.dm-header .btn-primary',
            title: 'Create a Regulator Export',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Create a Regulator Export',
            description: 'Generate a new PDP Committee breach notification report with jurisdiction-specific formatting.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Generate a new PDP Committee breach notification report with jurisdiction-specific formatting.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-header .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'export_form',
            target: '.dm-modal',
            wait_for: '.dm-modal',
            title: 'Export Form',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Export Form',
            description: 'Configure the export with jurisdiction, format, and included sections. This produces an audit-grade regulatory notification dossier with contributor lineage and submission timestamp.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Configure the export with jurisdiction, format, and included sections. This produces an audit-grade regulatory notification dossier with contributor lineage and submission timestamp.',
            position: 'right',
            action: { type: 'click', target: '.dm-form-actions button[type="button"]' },
            duration_ms: 300,
        },
        {
            step_id: 'incident_ops_complete',
            target: '.dm-page',
            title: 'Incident Ops Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Incident Ops Tour Complete',
            description: 'You can now manage operational incident response: SLA tracking against the 72-hour PDPL window, playbook execution, escalation logging, vendor coordination, and audit-grade regulator export packages.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage operational incident response: SLA tracking against the 72-hour PDPL window, playbook execution, escalation logging, vendor coordination, and audit-grade regulator export packages.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=incident-ops.js.map